export const PREVIEW_SECTION_IDS = {
  overview: 'preview-overview',
  details: 'preview-details',
  features: 'preview-features',
  description: 'preview-description',
} as const;
